<template>
  <div :class="bare ? '' : 'ful-section'" v-if="hasData">
    <div v-show="!bare || toggle" class="ful-drug-table-wrap">
      <div class="ful-drug-table">
        <div class="ful-drug-table-header">
          <span class="ful-dth-col">序号</span>
          <span class="ful-dth-col ful-dth-name">{{ isChaowei ? '品名' : '药品' }}</span>
          <span class="ful-dth-col ful-dth-weight">{{ isChaowei ? '数量（包）' : '重量（克）' }}</span>
          <span class="ful-dth-col ful-dth-col-2">序号</span>
          <span class="ful-dth-col ful-dth-name ful-dth-col-2">{{ isChaowei ? '品名' : '药品' }}</span>
          <span class="ful-dth-col ful-dth-weight ful-dth-col-2">{{ isChaowei ? '数量（包）' : '重量（克）' }}</span>
        </div>
        <div class="ful-drug-table-body">
          <div class="ful-drug-table-row" v-for="(item, idx) in drugRows" :key="'row-' + idx">
            <span class="ful-dtr-index" v-if="item.key">
              <span class="ful-dtr-index-circle">{{ item.index }}</span>
            </span>
            <span class="ful-dtr-name" v-if="item.key">{{ item.key }}</span>
            <span class="ful-dtr-weight" v-if="item.key">{{ item.value }}<template v-if="!isChaowei">g</template></span>
            <span class="ful-dtr-index ful-dtr-col-2" v-if="item.key1 != null && item.key1 !== ''">
              <span class="ful-dtr-index-circle">{{ item.index1 }}</span>
            </span>
            <span class="ful-dtr-name ful-dtr-col-2" v-if="item.key1 != null && item.key1 !== ''">{{ item.key1 }}</span>
            <span class="ful-dtr-weight ful-dtr-col-2" v-if="item.key1 != null && item.key1 !== ''">{{ item.value1 }}<template v-if="!isChaowei">g</template></span>
          </div>
        </div>
      </div>
      <!-- <div class="ful-drug-summary">
        <span class="ful-summary-asterisk">*</span>总计：<b>{{ count }}</b>味，<b>{{ totalWeight }}</b>克<span v-if="showCharge && charge && charge != 0">；参考药价：<b>{{ charge }}元/副</b></span>
      </div>
      <div class="ful-drug-summary" v-if="decoctionTotalWeight">
        <span class="ful-summary-asterisk">*</span>饮片重量：<b>{{ decoctionTotalWeight }}</b>克<span v-if="decoctionPrice && decoctionPrice != 0">；参考药价：<b>{{ decoctionPrice }}元/副</b></span>
      </div>
      <div class="ful-drug-summary granules-summary" v-if="granulesTotalWeight">
        <span class="ful-summary-asterisk">*</span>颗粒重量：<b>{{ granulesTotalWeight }}</b>克<span v-if="granulesSumPrice && granulesSumPrice != 0">；参考药价：<b>{{ granulesSumPrice }}元/副</b></span>
      </div> -->
      <div class="ful-drug-footer" v-if="showSupplyDays">
        <span class="ful-summary-asterisk">*</span>
        <span v-if="timeRange">有效使用期：<b>{{ displayStartDate }} {{ timeRange }}</b></span>
        <span v-else>有效使用期：<b>{{ displayStartDate }} ~ {{ displayEndDate }}，{{ isChaowei ? '该方案' : '该处方' }}有效期{{ supplyDays }}天。</b></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DrugTable',
  props: {
    tablePrescription: { type: Object, default: () => ({}) },
    orderInfo: { type: Object, default: () => ({}) },
    bare: { type: Boolean, default: false },
    timeRange: { type: String, default: '' },
    supplyDays: { type: [Number, String], default: '' },
    showCharge: { type: Boolean, default: true },
    showSupplyDays: { type: Boolean, default: false },
    // 超微饮片模式：表头改为「品名 / 数量（包）」，重量数值不带 g
    chaoweiMode: { type: Boolean, default: false }
  },
  data() {
    return { toggle: true }
  },
  computed: {
    isChaowei() {
      return !!this.chaoweiMode
    },
    // 超微饮片场景下：将 yyyyMMdd 紧凑格式转 yyyy-MM-dd；普通场景保持原值
    displayStartDate() {
      return this.isChaowei ? this.normalizeDate(this.startDate) : this.startDate
    },
    displayEndDate() {
      return this.isChaowei ? this.normalizeDate(this.endDate) : this.endDate
    },
    prescriptionArray() {
      // 兼容多种字段名
      const tp = this.tablePrescription || {}
      if (Array.isArray(tp.drugList)) return tp.drugList
      if (Array.isArray(tp.herbs)) return tp.herbs
      if (Array.isArray(tp.drugs)) return tp.drugs
      return []
    },
    // 已配对数据（每项含 key1/value1，一行两味药），优先使用
    pairedArray() {
      const tp = this.tablePrescription || {}
      if (Array.isArray(tp.options) && tp.options.length > 0) return tp.options
      return []
    },
    // 未配对数据（每项只有 key/value，需要两两配对）
    unpairedArray() {
      const tp = this.tablePrescription || {}
      if (Array.isArray(tp.prescription) && tp.prescription.length > 0) return tp.prescription
      return []
    },
    hasData() {
      return this.pairedArray.length > 0 || this.unpairedArray.length > 0 || this.count > 0
    },
    drugRows() {
      // 已配对的 options 每行已经包含左右两味药，直接返回，避免再次两两配对
      if (this.pairedArray.length > 0) {
        return this.pairedArray.map(item => Object.assign({}, item))
      }
      // 否则将未配对的 prescription 两两配对
      const arr = this.unpairedArray
      const rows = []
      for (let i = 0; i < arr.length; i += 2) {
        const left = arr[i] || {}
        const right = arr[i + 1]
        const row = Object.assign({}, left)
        if (right && right.key !== undefined && right.key !== null && right.key !== '') {
          row.key1 = right.key
          row.value1 = right.value
          row.index1 = right.index
        }
        rows.push(row)
      }
      return rows
    },
    count() { return this.tablePrescription.count || 0 },
    totalWeight() { return this.tablePrescription.totalWeight || 0 },
    charge() { return this.tablePrescription.charge || 0 },
    startDate() { return this.tablePrescription.startDate || '' },
    endDate() { return this.tablePrescription.endDate || '' },
    decoctionTotalWeight() { return this.tablePrescription.decoctionTotalWeight || this.tablePrescription.totalWeight || 0 },
    decoctionPrice() { return this.tablePrescription.decoctionPrice || this.tablePrescription.charge || 0 },
    granulesTotalWeight() { return this.tablePrescription.granulesTotalWeight || 0 },
    granulesSumPrice() { return this.tablePrescription.granulesSumPrice || 0 }
  },
  methods: {
    // 超微饮片场景下：把 yyyyMMdd 紧凑格式转换为 yyyy-MM-dd；其他格式原样返回
    normalizeDate(value) {
      if (!value) return ''
      const str = String(value)
      if (str.length === 8 && /^\d{8}$/.test(str)) {
        return str.substring(0, 4) + '-' + str.substring(4, 6) + '-' + str.substring(6, 8)
      }
      return str
    }
  }
}
</script>

<style scoped>
.ful-drug-table-wrap { width: 100%; }

.ful-drug-table {
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid #dfeae3;
}

.ful-drug-table-header {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr 1fr 1.5fr 1fr;
  background: #20863F;
  padding: 14px 0;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.ful-dth-col {
  text-align: center;
}

.ful-dth-col:not(:first-child) {
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.ful-dth-name {
  text-align: left;
  padding-left: 20px;
}

.ful-dth-weight {
  text-align: center;
}

.ful-drug-table-body { display: flex; flex-direction: column; }

.ful-drug-table-row {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr 1fr 1.5fr 1fr;
  align-items: center;
  border-bottom: 1px solid #edf2ee;
  background: #fff;
  padding: 0;
  min-height: 56px;
}

.ful-drug-table-row:last-child {
  border-bottom: none;
}

.ful-drug-table-row:hover {
  background: #f8faf7;
}

.ful-drug-table-row > :not(:first-child) {
  border-left: 1px solid #edf2ee;
}

.ful-dtr-index {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
}

.ful-dtr-index-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #ef4444;
  color: #ef4444;
  font-size: 18px;
  font-weight: 600;
}

.ful-dtr-name {
  font-size: 18px;
  font-weight: 500;
  color: #1f3327;
  padding: 14px 20px;
}

.ful-dtr-weight {
  text-align: center;
  font-weight: 700;
  color: #20863F;
  font-size: 16px;
  padding: 14px 0;
}

.ful-drug-summary {
  background: #fcfdfc;
  padding: 14px 24px;
  font-size: 18px;
  border-top: 1px solid #edf2ee;
}
.ful-drug-summary:first-of-type {
  border-top: none;
}
.ful-drug-summary.granules-summary {
  border-radius: 0 0 16px 16px;
}
.ful-drug-summary b {
  color: #ef4444;
  font-weight: 700;
}
.ful-summary-asterisk {
  color: #ef4444;
  font-weight: 700;
}

/* 底部（有效使用期） */
.ful-drug-footer {
  background: #fcfdfc;
  padding: 12px 24px;
  font-size: 18px;
  margin-top: 1px;
  border-top: 1px solid #edf2ee;
}
.ful-drug-footer b {
  color: red;
  font-weight: 700;
}

@media (max-width: 768px) {
  .ful-drug-table-header { display: none; }
  .ful-drug-table-row {
    display: grid;
    grid-template-columns: 32px 1fr 55px 32px 1fr 55px;
    padding: 8px 10px;
    gap: 2px;
    align-items: center;
    min-height: auto;
  }
  .ful-dtr-index { padding: 0; }
  .ful-dtr-index-circle { width: 26px; height: 26px; font-size: 13px; }
  .ful-dtr-name { padding: 0; font-size: 15px; }
  .ful-dtr-weight { padding: 0; text-align: center; font-size: 15px; }
}
</style>
